import {
  DefaultConfigDetailsFactory,
  type DefaultConfigDetailsNavigation,
} from '@domains/subscription/priv/factories/DefaultConfigDetailsFactory'
import { createRoute } from '@domains/subscription/router/router'
import { useNavigate, useParams } from 'react-router-dom'

export const DefaultConfigDetailsPage = () => {
  const { configId = '' } = useParams<'configId'>()
  const navigate = useNavigate()

  const navigation: DefaultConfigDetailsNavigation = {
    back: () => navigate(createRoute.subscription()),
  }

  return <DefaultConfigDetailsFactory configId={configId} navigation={navigation} />
}
